import questionTypes from '../questionTypes';

import getCommonBlockProps from './getCommonBlockProps';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';
import buttonBlockToFormInitialValues from './buttonBlockToFormInitialValues';

export default {
  type: questionTypes.redirectButton,
  pickBlockPropsToInitialValues: buttonBlockToFormInitialValues,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    label: 'Redirect',
    url: '#',
    alignment: 'center',
  }),
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isUniqueField: sectionName => sectionName === 'landing',
    isRequiredField: sectionName => sectionName === 'landing',
    isTextRequired: () => false,
  },
};
